import { Box, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Area,
  AreaChart,
  BarChart,
  Bar,
} from "recharts";

const data = [
  { month: "Jan", value: 520, growth: 5 },
  { month: "Feb", value: 580, growth: 18 },
  { month: "Mar", value: 620, growth: 12 },
  { month: "Apr", value: 480, growth: 8 },
  { month: "May", value: 550, growth: 28 },
  { month: "Jun", value: 720, growth: 2 },
  { month: "Jul", value: 680, growth: 12 },
  { month: "Aug", value: 490, growth: 5 },
  { month: "Sep", value: 460, growth: 25 },
  { month: "Oct", value: 580, growth: 8 },
  { month: "Nov", value: 650, growth: 5 },
  { month: "Dec", value: 780, growth: 35 },
];

export default function DualChartDashboard({ sidebarOpen = true }) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isSmallScreen = isXs || isSm || isMd;

  // Calculate sidebar width based on state
  const sidebarWidth = sidebarOpen ? 200 : 100;

  return (
    <Box
      style={{
        padding: isXs ? "12px" : isSm ? "16px" : isMd ? "20px" : "24px",
        // backgroundColor: "#f8fafc",
        marginLeft: isSmallScreen ? "0" : `${sidebarWidth}px`,
        marginTop: "-3%",
        marginRight: isSmallScreen ? "0" : "1.3%",
        fontFamily: "Outfit",
        marginBottom: "-3%",
        transition: "margin-left 0.3s ease",
      }}
    >
      {/* Main Chart Card */}
      <Box
        style={{
          backgroundColor: "white",
          borderRadius: "16px",
          padding: isXs ? "16px" : isSm ? "24px" : isMd ? "32px" : "40px",
          // boxShadow: "0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)",
          marginBottom: "24px",
          // border: "1px solid #f1f5f9",
        }}
      >
        {/* Header Section - Full Width */}
        <Box
          style={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            justifyContent: isSmallScreen ? "flex-start" : "space-between",
            alignItems: isSmallScreen ? "flex-start" : "flex-start",
            marginBottom: isXs
              ? "20px"
              : isSm
              ? "30px"
              : isMd
              ? "35px"
              : "40px",
            paddingBottom: isXs ? "12px" : "20px",
            gap: isSmallScreen ? "16px" : "0",
          }}
        >
          {/* Left Side - Revenue Analysis */}
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              width: isSmallScreen ? "100%" : "auto",
            }}
          >
            <h2
              style={{
                margin: "0",
                fontSize: isXs ? "16px" : "18px",
                fontWeight: "700",
                color: "#2B3674",
                fontFamily: "Outfit",
                letterSpacing: "-0.025em",
                marginLeft: isSmallScreen ? "0" : "-35%",
                textAlign: isSmallScreen ? "left" : "center",
              }}
            >
              Revenue analysis
            </h2>
            {/* <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0",
                marginLeft: "-2%",
              }}
            >
              <span
                style={{
                  color: "#05CD99",
                  fontSize: "15px",
                  fontWeight: "700",
                  marginRight: "6px",
                  fontFamily: "Outfit",
                }}
              >
                +23%
              </span>
              <span
                style={{
                  color: "#A3AED0",
                  fontSize: "16px",
                  fontWeight: "400",
                  fontFamily: "Outfit",
                }}
              >
                Increased lorem ipsum
              </span>
            </Box> */}
          </Box>

          {/* Center - Growth Analysis */}
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              textAlign: isSmallScreen ? "left" : "center",
              marginLeft: isSmallScreen ? "0" : "190px",
              width: isSmallScreen ? "100%" : "auto",
            }}
          >
            <h2
              style={{
                margin: "0",
                fontSize: isXs ? "16px" : "18px",
                fontWeight: "700",
                color: "#2B3674",
                fontFamily: "Outfit",
                marginLeft: isSmallScreen ? "0" : "-8%",
                letterSpacing: "-0.025em",
              }}
            >
              Growth analysis
            </h2>
            {/* <Box
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0",
                // marginLeft: "15%",
                width: "100%",
                marginLeft: isSmallScreen ? "0" : "15%",

                justifyContent: isSmallScreen ? "flex-start" : "center",
              }}
            >
              <span
                style={{
                  color: "#05CD99",
                  fontSize: "15px",
                  fontWeight: "700",
                  marginRight: "6px",
                  fontFamily: "Outfit",
                }}
              >
                +23%
              </span>
              <span
                style={{
                  color: "#A3AED0",
                  fontSize: "16px",
                  fontWeight: "400",
                  fontFamily: "Outfit",
                }}
              >
                Increased lorem ipsum
              </span>
            </Box> */}
          </Box>

          {/* Right Side - Buttons */}
          <Box
            style={{
              display: "flex",
              gap: "6px",
              width: isSmallScreen ? "100%" : "auto",
              justifyContent: isSmallScreen ? "flex-start" : "flex-end",
            }}
          >
            {/* <button
              style={{
                backgroundColor: "#4BC7E180",
                color: "#282828",
                padding: "7px 14px",
                borderRadius: "6px",
                border: "none",
                fontSize: "12px",
                fontWeight: "500",
                cursor: "pointer",
                boxShadow: "none",
                fontFamily: "Roboto",
              }}
            >
              Monthly
            </button> */}
            {/* <button
              style={{
                backgroundColor: "#FFFFFF",
                color: "#282828",
                padding: "7px 14px",
                borderRadius: "6px",
                border: "1px solid #CFCFCF",
                fontSize: "12px",
                fontWeight: "500",
                cursor: "pointer",
                fontFamily: "Roboto",
              }}
            >
              Yearly
            </button> */}
          </Box>
        </Box>

        {/* Container for both charts */}
        <Box
          style={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            gap: isXs ? "24px" : isSm ? "32px" : isMd ? "40px" : "48px",
          }}
        >
          {/* Left Side - Revenue Analysis */}
          <Box style={{ flex: 1 }}>
            {/* Chart Container */}
            <Box style={{ position: "relative" }}>
              {/* Chart */}
              <Box
                style={{
                  width: "100%",
                  height: isXs ? "280px" : isSm ? "320px" : "360px",
                  filter: "blur(3px)",
                }}
              >
                <ResponsiveContainer width="100%" height="100%">
                  <AreaChart
                    data={data}
                    margin={{
                      top: 0,
                      right: isXs ? 10 : 30,
                      left: 0,
                      bottom: 20,
                    }}
                  >
                    <defs>
                      <linearGradient
                        id="colorRevenue"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop
                          offset="5%"
                          stopColor="#8b5cf6"
                          stopOpacity={0.25}
                        />
                        <stop
                          offset="95%"
                          stopColor="#8b5cf6"
                          stopOpacity={0.02}
                        />
                      </linearGradient>
                    </defs>
                    <CartesianGrid
                      strokeDasharray="0"
                      stroke="#e2e8f0"
                      horizontal={true}
                      vertical={false}
                      strokeWidth={0.8}
                    />
                    <XAxis
                      dataKey="month"
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: isXs ? 10 : 12, fill: "#94a3b8" }}
                      dy={10}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: isXs ? 9 : 11, fill: "#94a3b8" }}
                      domain={[0, 800]}
                      tickCount={9}
                      tickFormatter={(value) => `${value}K`}
                      width={isXs ? 35 : 40}
                    />
                    <Area
                      type="monotone"
                      dataKey="value"
                      stroke="#8b5cf6"
                      strokeWidth={2.5}
                      fill="url(#colorRevenue)"
                      dot={false}
                      activeDot={{
                        r: 4,
                        fill: "#8b5cf6",
                        stroke: "#fff",
                        strokeWidth: 2,
                      }}
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </Box>
              {/* Coming Soon Overlay */}
              <Box
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                  borderRadius: "8px",
                }}
              >
                <h3
                  style={{
                    margin: "0",
                    fontSize: isXs ? "20px" : isSm ? "24px" : "28px",
                    fontWeight: "700",
                    color: "#2B3674",
                    fontFamily: "Outfit",
                    textAlign: "center",
                    textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  Coming Soon
                </h3>
              </Box>
            </Box>
          </Box>

          {/* Right Side - Growth Analysis */}
          <Box style={{ flex: 1 }}>
            {/* Bar Chart */}
            <Box style={{ position: "relative" }}>
              <Box
                style={{
                  width: "100%",
                  height: isXs ? "280px" : isSm ? "320px" : "360px",
                  filter: "blur(3px)",
                }}
              >
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={data}
                    margin={{
                      top: 0,
                      right: isXs ? 10 : 30,
                      left: 0,
                      bottom: 20,
                    }}
                  >
                    <CartesianGrid
                      strokeDasharray="0"
                      stroke="#e2e8f0"
                      horizontal={true}
                      vertical={false}
                      strokeWidth={0.8}
                    />
                    <XAxis
                      dataKey="month"
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: isXs ? 10 : 12, fill: "#94a3b8" }}
                      dy={10}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: isXs ? 9 : 11, fill: "#94a3b8" }}
                      domain={[0, 40]}
                      tickCount={9}
                      width={isXs ? 25 : 30}
                    />
                    <Bar
                      dataKey="growth"
                      fill="#22d3ee"
                      radius={[10, 10, 0, 0]}
                      maxBarSize={isXs ? 20 : 28}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </Box>
              {/* Coming Soon Overlay */}
              <Box
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                  borderRadius: "8px",
                }}
              >
                <h3
                  style={{
                    margin: "0",
                    fontSize: isXs ? "20px" : isSm ? "24px" : "28px",
                    fontWeight: "700",
                    color: "#2B3674",
                    fontFamily: "Outfit",
                    textAlign: "center",
                    textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  Coming Soon
                </h3>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
